import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const integrationImportService = new CachedService(entities.Orderadmin_Integrations_Entity_Import, '/integrations/import', HALApiService, createItemsData)
